import { FormProvider, type UseFormReturn } from 'react-hook-form';
import { Checkbox } from '@/components/ui/checkbox';
import { Field, FieldLabel } from '@/components/ui/field';
import EventNotificationForm from './EventNotificationForm';
import type { EventNotificationFormValues } from './eventNotification';

type NotifyUsersSectionProps = {
  notifyUsers: boolean;
  onNotifyUsersChange: (notifyUsers: boolean) => void;
  notificationForm: UseFormReturn<EventNotificationFormValues>;
};

const NotifyUsersSection: React.FC<NotifyUsersSectionProps> = ({
  notifyUsers,
  onNotifyUsersChange,
  notificationForm,
}) => (
  <>
    <Field orientation="horizontal">
      <Checkbox
        id="newEventNotifyUsers"
        checked={notifyUsers}
        onCheckedChange={(checked) => onNotifyUsersChange(checked)}
      />
      <FieldLabel htmlFor="newEventNotifyUsers" className="tw:font-normal">
        Notify users when the event is created
      </FieldLabel>
    </Field>
    {notifyUsers && (
      <div className="mt-3">
        <FormProvider {...notificationForm}>
          <EventNotificationForm />
        </FormProvider>
      </div>
    )}
  </>
);

export default NotifyUsersSection;
